import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import REModal from "@streeteasy/design-system/deprecated/Modal";

import { largeScreen, smallScreen } from "src/shared/constants/screenSizes";
import ContactBoxHeader from "src/shared/contact-boxes/components/ContactBoxHeader";

export const Modal = styled(REModal)`
  /* Targeting the react-ui-component container */
  [aria-modal] {
    background-color: white;
    min-height: 100vh;
    top: 10%;
    top: 0;

    @media screen and (min-width: ${smallScreen}px) {
      height: auto;
      background-color: transparent;
      top: 1%;
      min-height: auto;
    }

    /* close button wrapper */
    [aria-label="close"] {
      &:before,
      &:after {
        background-color: white;
      }
    }

    > section {
      min-width: 100vw;

      @media screen and (min-width: ${smallScreen}px) {
        min-width: ${smallScreen}px;
        max-width: ${smallScreen}px;
      }

      @media screen and (min-width: ${largeScreen}px) {
        min-width: ${largeScreen}px;
        max-width: ${largeScreen}px;
      }
    }
  }
`;

export const ModalTitle = styled.div`
  color: white;
  font-size: 18px;
  font-weight: bold;
  height: 50px;
  left: 50px;
  line-height: 50px;
  position: absolute;
  text-align: center;
  top: 0;
  width: calc(100% - 100px);
`;

export const ModalBody = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;

  @media screen and (min-width: ${largeScreen}px) {
    flex-direction: row;
  }

  ${ContactBoxHeader} {
    display: none;
  }
`;

export const ModalLeft = styled.div`
  background: white;
  display: flex;
  flex: 7;
  padding: 20px;
`;

export const ModalRight = styled.div`
  align-items: center;
  background: ${colors.mouseGrey};
  border-left: solid 1px ${colors.rabbitGrey};
  display: flex;
  flex: 3;
  flex-direction: column;
  padding: 20px;

  @media screen and (max-width: ${largeScreen}px) {
    border: none;
    background: white;
    flex-direction: row;
  }
`;
